export function removeHTMLTags(str: string) {
  const stringWithoutHTML = str.replace(/<[^>]*>/g, "");
  const stringWithoutNbsp = stringWithoutHTML.replace(/&nbsp;/g, " ");
  return stringWithoutNbsp;
}
